import React, { FC, useEffect, useState } from "react";
import { TicketType } from "../types";
import CustomTooltip from "app/components/Tooltip";
import { getTicketIcon } from "../containers/Home/containers/helpers";
import Dropdown from "app/components/Dropdown"; 
import checkMark from "assets/svgs/checkmark.svg";
import {TicketTypeOptions} from "../data"
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { selectTicketTypes } from "app/redux/selector";
import {actions as appAction} from "app/redux/slice"
import { actions } from "../containers/Tickets/redux/slice";
import CommonTicketTypeSelection from "app/containers/Features/components/CommonTicketTypeSelection";
interface TicketTypeButtonProps {
  readonly type: TicketType; 
  readonly onTypeChange: (type: TicketType) => void;
  readonly onShowAddTask?: () => void;
}

export const TicketTypeButton: FC<TicketTypeButtonProps> = ({ type, onTypeChange,onShowAddTask }) => {
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState(''); 
  const ticketTypeOption = useSelector(selectTicketTypes) 
  const handleSelect = (selectedType: TicketType,id:string) => {
    dispatch(appAction.setStatusForSelectedTicketType({
      ticketTypeId: id,
    }));
    dispatch(actions.setTicketFormValue({name: 'type',value: id}));
    onTypeChange(selectedType);
  };

  useEffect(() => {
    //Set default ticket type ID
    const defaultTicketType = ticketTypeOption.find((option) => option.icon === type);
    if (defaultTicketType) {
      setSelectedValue(defaultTicketType._id);
      dispatch(actions.setTicketFormValue({ name: 'type', value: defaultTicketType._id }));
    } 
  }, [onShowAddTask]);
  
  return (
    <CommonTicketTypeSelection
      trigger={
        <button className="flex flex-row items-center gap-[4px] h-[28px] px-[6px] capitalize rounded-[4px] border border-[#E9ECF2] text-xs leading-[18px] font-medium text-secondary hover:bg-[#ECEEF2] hover:text-[#79808A] hover:border-[#E9ECF2] transition-all duration-200">
         <CustomTooltip text="Set ticket type" position="bottom">
            <div className="flex items-center gap-1 w-full">
              <img
                src={getTicketIcon(type)}
                alt="icon"
                className="size-[16px] max-w-[237px] max-h-[260px]"
              />
              <span className="text-sm">
                {type}
              </span>
            </div>
          </CustomTooltip>
        </button>
      }
      className="min-w-[237px]"
      align="start"
      showEndIcon
      showDefault
      isHeader="ticket types"
      value={selectedValue}
      isUnPaddedY={true}
      setValue={(data) => {
        handleSelect(data.icon as TicketType, data._id);
      }}      
    />
  );
};
